<template>
  <div class="box">
    <div id="layer" v-if="loadingIcon" />
    <cube-loading :size="35" class="loading" v-if="loadingIcon"></cube-loading>
    <div class="top">
      <ul class="list">
        <div class="item">
          <div class="input-container">
            <div
              class="left"
              style="font-size: 16px; font-weight: 400; margin-left: 70px; color: #f37423;"
            >
              <label for="bike" class="radio-tile-label" @click="login_out"
                >登出</label
              >
            </div>
          </div>
          <div class="input-container">
            <div class="middle" style="font-size: 16px; font-weight: bold">
              <label for="drive" class="radio-tile-label">功能選單</label>
            </div>
          </div>
          <div
            class="right"
            style="width:10px; font-size: 18px; font-weight: 400; margin-left: 50px"
          ></div>
        </div>
      </ul>
    </div>

    <!-- DEV NOTE:20210929 ping 功能選單 -->
    <div class="content">
      <div class="content_title">
        <span>人員：{{ staffNo }} </span>
        <span>分店：{{ shopName }} </span>
      </div>
      <cube-button class="item_botton" @click="toNews">最新消息</cube-button>
      <!-- DEV NOTE:20221223 ping #20221209_路易莎_店家小幫手查詢電話 -->
      <cube-button class="item_botton" @click="toPoint">點數查詢</cube-button>
      <!-- <cube-button class="item_botton" @click="toProducts"
        >商業咖啡豆</cube-button
      > -->
      <cube-button class="item_botton" @click="toMenu"
        >點餐供應狀態</cube-button
      >
      <!-- DEV NOTE:20230111 ping 調味供應狀態 -->
      <cube-button class="item_botton" @click="toBonusPage"
        >調味供應狀態</cube-button
      >
      <!-- DEV NOTE:20240813 ping 改為活動菜單供應裝態：進去再選擇對應的活動菜單分類，ex超值早餐品項 -->
      <cube-button class="item_botton" @click="toActivityMenu"
        >活動菜單供應狀態</cube-button
      >
      <cube-button class="item_botton" @click="toShopData"
        >門市資料</cube-button
      >
      <!-- <cube-button class="item_botton" @click="toState">關閉訂餐</cube-button> -->
      <cube-button class="item_botton" @click="toState">營業時間</cube-button>
      <!-- <cube-button class="item_botton" @click="toReport"
        >線上訂餐數據紀錄</cube-button
      > -->
      <!-- DEV NOTE:20240521 ping 進單列表 -->
      <cube-button class="item_botton" @click="toPOSList"
        >進單列表</cube-button
      >
    </div>

    <div class="bottom">
      <img src="../img/eilis.png" alt="Smiley face" height="24" width="" />
      <div style="transform: scale(0.7)">智慧互動助理提供</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      loadingIcon: false,
      shopNo: localStorage.getItem("shopNo"),
      staffNo: localStorage.getItem("staffNo"),
      shopName: "",
      // itemAllList: [],
      // itemShopList: [],
      // compareMenuList: [],
    };
  },
  mounted() {
    // if (localStorage.getItem("openOrderState") == "") {
    //   this.getShopState();
    // }
    // DEV NOTE:20211012 ping 若沒有店號跳回登入頁面
    if (
      localStorage.getItem("shopNo") == null ||
      localStorage.getItem("shopNo") == ""
    ) {
      this.$router.push(`/login`);
    }
    this.getShopName();
    // this.firstGetMenu();
    // this.getCompareMenu();
  },
  computed: {
    // DEV NOTE:20220506 ping 儲存店家營業時間
    ...mapGetters({
      shopOpenTime: "shopOpenTime",
    }),
    shopOpenTime: {
      get() {
        return this.shopOpenTime;
      },
      set(value) {
        this.updateShopOpenTime({ shopOpenTime: value });
      },
    },
  },
  methods: {
    ...mapActions({
      getItem: "getItem",
      getMenu: "getMenu",
      getStoreThrNumber: "getStoreThrNumber",
    }),
    ...mapMutations({
      updateShopOpenTime: "updateShopOpenTime",
    }),

    // DEV NOTE:20211006 ping 取得店家菜單
    // firstGetMenu() {
    //   this.loadingIcon = true;
    //   this.getMenu({ shopNo: this.shopNo }).then((res) => {
    //     // console.log(res);
    //     this.itemShopList = res.data.result.menu;
    //     console.log("店家菜單：");
    //     console.log(this.itemShopList);
    //     this.shopMenu = this.itemShopList;
    //     this.loadingIcon = false;
    //   });
    // },

    // DEV NOTE:20211006 ping 總部與店家菜單比對
    // getCompareMenu() {
    //   // DEV NOTE:20211006 ping 取得總部所有菜單
    //   this.getItem().then((res) => {
    //     // console.log(res);
    //     this.itemAllList = res.data;
    //     console.log("總部菜單：");
    //     console.log(this.itemAllList);
    //   });

    //   // DEV NOTE:20211006 ping 取得店家菜單
    //   this.getMenu({ shopNo: this.shopNo }).then((res) => {
    //     // console.log(res);
    //     console.log("店家菜單：");
    //     this.itemShopList = res.data.result.menu;
    //     console.log(this.itemShopList);
    //   });

    //   // DEV NOTE:20211006 ping 假如總部菜單長跟店家菜單長相符
    //   setTimeout(() => {
    //     console.log(this.itemAllList.length);
    //     console.log(this.itemShopList.length);
    //     if (this.itemAllList.length === this.itemShopList.length) {
    //       console.log(this.itemAllList.map((x) => x.foods));
    //     }
    //   }, 1500);
    // },
    // DEV NOTE:20220208 ping 取得店名
    getShopName() {
      this.loadingIcon = true;
      let nowShopNumber = this.shopNo.split();
      // DEV NOTE:20211001 ping 取得店家訂餐狀態
      this.getStoreThrNumber({
        shopNoList: nowShopNumber,
      }).then((res) => {
        // console.log("173", res);
        // DEV NOTE:20220506 ping 存店家營業時間
        let open = {
          openTime: res.data[0].openTime,
          openType: res.data[0].openType,
          closeTime: res.data[0].closeTime,
          openTime2: res.data[0].openTime2,
        }
        this.shopOpenTime = {
          shopNo: this.shopNo,
          open: open
        }

        this.shopName = res.data[0].name;
        // DEV NOTE: 20240625 ping 存店名
        localStorage.setItem("shopName", this.shopName);
        if (localStorage.getItem("openOrderState") == "") {
          this.getMenu({ shopNo: this.shopNo }).then((res) => {
            // console.log("177", res);
            this.openOrderState = res.data.result.openOrder;
            localStorage.setItem("openOrderState", res.data.result.openOrder);
            this.loadingIcon = false;
          });
        } else {
          this.loadingIcon = false;
        }
      });
    },
    login_out() {
      this.$router.push(`/login`);
    },
    // DEV NOTE:20210930 前往最新消息
    toNews() {
      this.$createDialog({
        type: "alert",
        title: "提示",
        content: "即將推出",
        icon: "cubeic-alert",
        confirmBtn: {
          text: "確定",
          active: true,
          disabled: false,
          // href: "javascript:;",
        },
      }).show();
    },
    // DEV NOTE:20210930 前往點數查詢
    toPoint() {
      this.$router.push(`/point`);
    },
    // DEV NOTE:20211115 商業咖啡豆
    toProducts() {
      this.$router.push(`/products`);
    },
    // DEV NOTE:20231011 ping 所有調味狀態
    toBonusPage() {
      this.$router.push(`/BonusPage`);
    },
    // DEV NOTE:20240813 ping 活動菜單
    toActivityMenu() {
      this.$router.push(`/ActivityMenu`);
    },
    // DEV NOTE:20230927 ping 超值早餐開關
    // toBreakfastCombo() {
    //   this.$router.push(`/BreakfastCombo`);
    // },
    // DEV NOTE:20210930 前往餐點供應狀態
    toMenu() {
      this.$router.push(`/menu`);
    },
    // DEV NOTE:20210930 前往門市資訊
    toShopData() {
      this.$createDialog({
        type: "alert",
        title: "提示",
        content: "即將推出",
        icon: "cubeic-alert",
        confirmBtn: {
          text: "確定",
          active: true,
          disabled: false,
          // href: "javascript:;",
        },
      }).show();
    },
    // DEV NOTE:20210930 前往關閉訂餐
    toState() {
      this.$router.push(`/orderState`);
    },
    // DEV NOTE: 20240521 ping 進單列表
    toPOSList() {
      this.$router.push(`/POSList`);
    },
    // DEV NOTE: 20220105 ping 線上訂餐數據紀錄
    toReport() {
      this.loadingIcon = true;
      let nowShopNumber = this.shopNo.split();
      this.getStoreThrNumber({
        shopNoList: nowShopNumber,
      }).then((res) => {
        this.loadingIcon = false;
        if (res.data[0].ads.filter((e) => e.title == "數據報表").length == 0) {
          this.$createDialog({
            type: "alert",
            title: "提示",
            content: "尚無數據報表",
            icon: "cubeic-alert",
            confirmBtn: {
              text: "確定",
              active: true,
              disabled: false,
              // href: "javascript:;",
            },
          }).show();
        } else {
          this.$router.push(`/report`);
        }
      });
      // this.$router.push(`/report`);
    },
  },
};
</script>

<style lang="scss" scoped>
#layer {
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(181, 181, 181, 0.419);
}
.loading {
  z-index: 10000;
  display: flex; // 置中
  align-items: center; // 置中
  justify-content: center; // 置中
  margin: 0 auto;
  position: fixed;
  top: 55%;
  left: 0;
  right: 0;
  // margin-top: -270px;
  width: 55px;
  height: 55px;
  color: #ffffff;
  border-radius: 5px;
  background-color: #717171;
  -webkit-text-fill-color: transparent;
}

.top {
  position: fixed;
  z-index: 10000;
  margin: 0px auto;
  margin-left: 0px;
  width: 100%;
  height: 50px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 1px 5px 1px rgba(0, 0, 0, 0.4);
}
.top .list {
  margin-left: -50px;
  text-align: left;
  height: 50px;
  width: 114vw;
}
.top .list .item {
  margin-top: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-content: space-between;
  border-bottom: 1px solid rgba(210, 210, 210, 0.815);
  height: 50px;
  width: 100%;
  padding: 0px;
}

.item_botton {
  width: 70%;
  height: 60px;
  margin: 0 auto;
  font-size: 18px;
  border-radius: 5px;
  margin-top: 40px;
  color: rgb(255, 255, 255);
  background-color: #f37423;
}

.content {
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding-top: 60px;
}

.bottom {
  font-size: 10px;
  position: relative;
  margin-top: 130px;
  padding-bottom: 20px;
}

.content_title {
  width: 70%;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: -10px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
</style>
